import React, { useEffect } from 'react';
import { Icon, Button } from 'components';
import { useSelect, useAction, useQuery } from 'hooks';
import { withForm, withFormValidation } from 'hoc';
import { get } from 'lodash';
import { Link, useHistory } from 'react-router-dom';
import {  toast } from 'react-toastify';
import Guideline from '../guideline/Guideline';

const initState = {
  email: '',
  password: ''
}

function LogIn({ value, onChange, isPassed }) {
  const query = useQuery()
  const history = useHistory()
  const isLoading = useSelect('loading.isLoading', { type: 'auth.login' })
  const isVerifying = useSelect('loading.isLoading', { type: 'auth.verify' })
  const loginAction = useAction('auth.login')
  const verifyAccount = useAction('auth.verify')
  useEffect(() => {
    if(query.get('token')){
      const toastId = toast.info('Verifying your account, pleasse wait...', { autoClose: false, position: 'top-center' })
      history.push('/')
      verifyAccount({ token: query.get('token') }, () => {
        toast.dismiss(toastId);
      })
    }
  }, [query.get('token')])



  const handleSubmit = e => {
    e.preventDefault()
    loginAction(value.email, value.password)
  }

  return (
    <div className="login-container">
      <div className="form-container">
        <form className="form w-full flex flex-grow" onSubmit={handleSubmit}>
          <div className="xl:!hidden lg:!hidden flex flex-col items-center justify-center flex-grow">
            <Icon.Logo className="lw-36 h-36"/>
            <span className="text-xs text-center">Land Transportation Franchising & Regulatory Board</span>
            <span className="text-sm font-bold text-center">Online Application and Issuance of Certificate of Public Convenience</span>
          </div>
          <div className="hidden xl:flex lg:flex flex-grow justify-center">
            <Icon.Logo className="lw-36 h-36"/>
          </div>

          <div className="flex items-center xl:!pb-16 pb-5">
            <Link to="/" className="w-full h-16 flex text-black items-center justify-center rounded-none border-b-4 border-warning"><span className="xl:!text-2xl lg:text-xl text-sm font-bold">Guidelines</span></Link>
            <Link to="/login" className="w-full h-16 flex text-black items-center justify-center rounded-none"><span className="xl:!text-2xl lg:text-xl text-sm font-bold">Sign In</span></Link>
            <Link to="/sign-up" className="w-full h-16 flex text-black items-center justify-center"><span className="xl:!text-2xl lg:text-xl text-sm font-bold">Create Account</span></Link>
          </div>
          <div className="overflow-auto border mt-0 guideline-public-container border-gray-500 rounded">
            <Guideline />
          </div>

        </form>
      </div>
      <div className="brand xl:!flex lg:!flex !hidden">
        <div className="content">
          <span className="title">Land Transportation Franchising & Regulatory Board</span>
          <span className="sub-title">Online Application and Issuance of Certificate of Public Convenience</span>
        </div>
      </div>
    </div>
  );
}


export default withForm(withFormValidation(LogIn,
  {
    email: 'required|email',
    password: 'required'
  },
), initState);
